// The phone of a child with no mail has no account to read its waiting page with: it keeps the
// token of the link it shares with the tutore, and reads the page by it (spec #278, #294).

const STORAGE_KEY = 'volee-enrolment-link'

function tokenOf(url: string): string | null {
  try {
    return new URL(url).searchParams.get('token')
  } catch {
    return null
  }
}

export const enrolmentLinkMemory = {
  remember(url: string): void {
    const token = tokenOf(url)
    if (token === null) return
    try {
      window.localStorage.setItem(STORAGE_KEY, token)
    } catch {
      // Private windows and blocked site data refuse it: the page then needs a sign-in, as before.
    }
  },
  read(): string | null {
    try {
      return window.localStorage.getItem(STORAGE_KEY)
    } catch {
      return null
    }
  },
  forget(): void {
    try {
      window.localStorage.removeItem(STORAGE_KEY)
    } catch {
      // Nothing was kept, so nothing is left behind.
    }
  },
}
